
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import GetRequest from '../../../service/GetRequest';


const PromotionCouponsTable = () => {
    const [promotions, setPromotions] = useState([]);

    useEffect(() => {

        GetRequest("v1/store-management-service/view/my/store", true)
        .then(storeDetails => {
            if (!storeDetails || !storeDetails.storeBranches) {
                console.error("Empty response or undefined data for store branches");
            } else {
                const response = GetRequest(`v1/store-management-service/view/promotions?storeId=${storeDetails.id}`);
                if (!response || response.length === 0) {
                    console.log("Empty response or undefined data for categories");
                    return []; // Return an empty array if response is empty or undefined
                } else {
                setPromotions(response); // Return the response array
                }
            }
        })
        .catch(error => {
            console.error("Error fetching store details:", error);
        });
    }, []);

    const headerContent = (
        <div className="flex justify-content-end">
            <Button label="Add promotion" icon="pi pi-plus" iconPos="left"/>
        </div>
    );


  return (
    <div className="card">
            <DataTable value={promotions} stripedRows header={headerContent} scrollable scrollHeight="400px" style={{ minWidth: '50rem' }}>
                <Column field="name" header="Id"></Column>
                <Column field="country.name" header="Code" sortable></Column>
                <Column field="representative.name" header="Type"></Column>
                <Column field="company" header="Maximum Discount"></Column>
                <Column field="company" header="Minimum Order Amount"></Column>
                <Column field="company" header="Start Date"></Column>
                <Column field="company" header="End date"></Column>
                <Column field="company" header="Promotion used (No of times)"></Column>
                <Column field="company" header="Action"></Column>

            </DataTable>
        </div>
  )
}

export default PromotionCouponsTable
